import React from "react";
import { motion } from "framer-motion";

function Relive() {
  return (
    <section className="relive-con position-relative">

      {/* RIGHT BOTTOM IMAGE */}
      

      <div className="container position-relative">
        <div className="row">

          {/* LEFT SIDE IMAGES */}
          <div className="col-lg-6 text-lg-left text-center order-lg-1 order-2">
            <div className="relive_wrapper">            

              

            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="col-lg-6 order-lg-2 order-1">
            <div className="relive_content">

              <motion.h2
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.5 }}
              >
                What iS <span>Gelato?</span>
              </motion.h2>

              <p>
                The Festivo Difference: Unlike traditional frozen desserts,
                our gelato is made with more milk and less cream for a
                naturally lower fat content while delivering a richer flavor.
              </p>

              {/* KEY BENEFITS */}
              <div className="gelato-benefits">

                <div className="benefit-item">
                  <h5>Slow Churned</h5>
                  <p>
                    Less air incorporation results in a naturally dense,
                    smooth texture.
                  </p>
                </div>

                <div className="benefit-item">
                  <h5>Served Warmer</h5>
                  <p>
                    We serve our gelato a few degrees warmer than deep-frozen
                    desserts so flavors release more easily.
                  </p>
                </div>

                <div className="benefit-item">
                  <h5>Pure Ingredients</h5>
                  <p>
                    No artificial preservatives or unnecessary additives —
                    just real, fresh ingredients.
                  </p>
                </div>

              </div>

              <a href="/about" className="all_button">
                Know More <i className="fa-solid fa-arrow-right"></i>
              </a>              

            </div>
          </div>

        </div>

        {/* MAIN CENTER IMAGE */}
        <figure className="relive-image mb-0">
          <motion.img
            src="/assets/images/img.png"
            alt="image"
            className="img-fluid"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.2, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.5 }}
          />
        </figure>

      </div>
    </section>
  );
}

export default Relive;